import { mailProAPIConstants } from "_constants";
import axios from "common/interceptors";  
export const mailProUtils = {
  approveMailProAreaAPI,
};

async function approveMailProAreaAPI(listgenUserID, areaID) {
  return await axios({
    method: "GET",
    headers: {
      "content-type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: {},
    params: {
        listgenUserID,
        areaID,
    },
    url: `${mailProAPIConstants.APPROVE_MAILPRO_AREA_API}`,
  });
}
